export default __webpack_public_path__ + "static/media/logo_TAIL.aca7340f.svg";